import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { Loadable } from '../base/components/Lodable'

const EventosGestion = Loadable(lazy(() => import('./view/EventosGestion')))
const EventosSistemaGestion = Loadable(lazy(() => import('./view/EventosSistemaGestion')))
export const eventosRoutesMap = {
  gestion: {
    path: '/eventos/gestion',
    name: 'Gestión de Eventos',
    actionSecure: 'Crear Evento',
  },
  gestionEvs: {
    path: '/eventos/gestion-eventos-sistema',
    name: 'Gestion Eventos Sistema',
    actionSecure: 'Procesar EventoSistema',
  },
}
const eventosRoutes = [
  {
    path: eventosRoutesMap.gestion.path,
    element: <EventosGestion />,
    auth: authRoles.admin,
  },
  {
    path: eventosRoutesMap.gestionEvs.path,
    element: <EventosSistemaGestion />,
    auth: authRoles.admin,
  },
]
export default eventosRoutes
